module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1BhqMkA/tc-custom/9781685504120.jpg?1723407260300",
      "alt": "This image is the cover for the book Against a Wounded Landscape"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Against a Wounded Landscape\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Sir Tanash, the greatest knight Tasora has ever known, has one quest -- to rescue his king’s only son. Fifteen years ago, Princy Liseny was kidnapped, and in the time since, Tasora has crumbled. By bringing the prince home, Tanash hopes to return the kingdom to its former glory."), _c('br'), _c('br'), _vm._v("As captive in a rival land, Liseny has spent most of his life locked away from the world, brought out as the ultimate prize while his real home is slowly destroyed. Escape is a godsend. So is Tanash, but neither is as simple as Liseny hopes. He has to learn to adjust in more ways than one. Though Tanash refuses to act on their mutual attraction, he does agree to help Liseny seek out an alliance to take back to Tasora."), _c('br'), _c('br'), _vm._v("What he doesn’t expect is to fall for the young prince along the way ...")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Vivien Dean\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0